function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3219 7.54828L7.54816 24.322",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67508 9.09863L7.51049 24.2833",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7714 24.1951L7.51048 24.2835",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.629 16.9057L35.6113 16.8985C35.419 16.8985 35.224 16.9173 35.0353 16.8914C34.4664 16.8118 33.9852 16.589 34.0004 15.92C34.0147 15.251 34.4816 15.0238 35.0764 15.022C37.2159 15.014 35.6864 15.014 36.775 15.022C42.0387 15.0229 47.3041 15.0301 52.5678 15.0238C54.244 15.0211 55.447 13.8333 55.4264 12.2475C55.4076 10.7512 54.2001 9.56963 52.6939 9.5741C51.1797 9.57857 49.9749 10.8397 50.0205 12.3772C50.0268 12.5686 50.0643 12.7591 50.0777 12.9505C50.1189 13.5346 49.8917 13.9505 49.2844 14.0391C48.6744 14.1276 48.3148 13.7806 48.2138 13.2153C48.0313 12.201 48.1127 11.2091 48.5876 10.2682C49.5956 8.27719 51.7458 7.29333 53.9077 7.84519C55.9872 8.37558 57.3753 10.2923 57.3011 12.5293C57.2313 14.658 55.6902 16.4665 53.5105 16.7912C52.3809 16.9602 51.2154 16.9182 50.0661 16.9245C47.254 16.9414 44.4411 16.9298 41.629 16.9298V16.9057Z",
  fill: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.5342 19.2116C44.128 19.2116 46.7227 19.2125 49.3165 19.2107C51.057 19.2107 52.5158 20.4405 52.6581 22.063C52.836 24.1067 51.7386 25.3312 49.9229 25.6863C48.2083 26.0208 46.6377 24.9073 46.2871 23.1935C46.1807 22.6703 46.3676 22.2875 46.8703 22.1122C47.3711 21.9378 47.762 22.1265 48.0241 22.5782C48.084 22.681 48.1153 22.8 48.1609 22.91C48.4623 23.6318 48.999 23.9359 49.6841 23.774C50.4256 23.5978 50.8576 23.0263 50.786 22.3152C50.7172 21.6256 50.1653 21.1185 49.4051 21.1131C47.0992 21.0988 44.7934 21.1069 42.4876 21.1069C39.5351 21.1078 38.5398 21.0818 35.5882 21.0818C35.4433 21.0818 35.2984 21.0908 35.1562 21.0738C34.5971 21.0085 34.1902 20.75 34.1481 20.1436C34.1133 19.6329 34.573 19.2196 35.2107 19.2116C36.7938 19.1937 36.4199 19.2304 38.003 19.2295C39.18 19.2286 40.3571 19.2286 41.5342 19.2286V19.2116Z",
  fill: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.1171 12.7488C36.5564 12.7488 36.9511 12.7557 35.3912 12.7459C34.6256 12.7414 34.1524 12.3863 34.1399 11.847C34.1265 11.2701 34.6184 10.8756 35.4073 10.8738C38.4331 10.8694 39.5035 10.8777 42.5293 10.8732C43.3495 10.8714 43.9327 10.3867 44.0015 9.68902C44.0713 8.98779 43.6232 8.35812 42.93 8.18371C42.2574 8.01466 41.6465 8.37869 41.3263 9.18457C41.0991 9.75521 40.7441 10.062 40.1144 9.87506C39.5285 9.70065 39.3344 9.17383 39.5679 8.46008C39.9587 7.25977 41.1537 6.3421 42.4229 6.26607C43.7779 6.18557 45.0605 6.95567 45.6052 8.17924C46.5703 10.3473 45.0453 12.7256 42.6581 12.7515C41.1448 12.7685 39.6305 12.7551 38.1171 12.7551V12.7488Z",
  fill: "#F0F0F5"
});

function SvgWindNe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindNe);
export default __webpack_public_path__ + "static/media/wind-NE.5494dba7.svg";
export { ForwardRef as ReactComponent };